export default __webpack_public_path__ + "static/media/pexels-dibert-1117210.4a2e319a.jpg";